// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab--active[data-v-1df89d70]{background-color:var(--v-primary-base)!important;border-radius:50px;color:#fff}", ""]);
// Exports
module.exports = exports;
